module.exports = __webpack_public_path__ + "static/item--chloe--f5@3x.4ab82b22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--chloe--f5@3x.png
// module id = 639
// module chunks = 126511778744290